import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = {
  class: "d-flex justify-space-between align-center",
  style: {"width":"100%"}
}
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = {
  key: 2,
  class: "text-center pa-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.show,
    "onUpdate:modelValue": _ctx.closeDialog,
    "max-width": "800px",
    persistent: "",
    scrollable: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createElementVNode("span", null, "Select Functions for Tools", -1)),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                icon: "",
                onClick: _ctx.closeDialog,
                variant: "text",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createTextVNode("mdi-close")
                    ])),
                    _: 1,
                    __: [0]
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1,
            __: [1]
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_text, { style: {"max-height":"70vh"} }, {
            default: _withCtx(() => [
              (_ctx.loadingFunctions)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      color: "primary",
                      class: "my-4"
                    }),
                    _cache[2] || (_cache[2] = _createElementVNode("p", null, "Loading functions...", -1))
                  ]))
                : (_openBlock(), _createBlock(_component_v_expansion_panels, {
                    key: 1,
                    variant: "accordion"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serversWithFunctions, (server) => {
                        return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                          key: server.name,
                          disabled: !server.functions || server.functions.length === 0
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_expansion_panel_title, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                  _createElementVNode("span", null, _toDisplayString(server.name), 1),
                                  (server.functions && server.functions.length > 0)
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 0,
                                        size: "small",
                                        color: _ctx.allFunctionsSelectedForServer(server.name) ? 'success' : 'grey',
                                        class: "ml-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString((_ctx.localSelectedFunctions[server.name] || []).length) + " / " + _toDisplayString(server.functions.length) + " selected ", 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["color"]))
                                    : (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 1,
                                        size: "small",
                                        color: "warning",
                                        class: "ml-2"
                                      }, {
                                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                                          _createTextVNode(" No functions available or failed to load ")
                                        ])),
                                        _: 1,
                                        __: [3]
                                      }))
                                ])
                              ]),
                              _: 2
                            }, 1024),
                            (server.functions && server.functions.length > 0)
                              ? (_openBlock(), _createBlock(_component_v_expansion_panel_text, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_3, [
                                      _createVNode(_component_v_btn, {
                                        size: "small",
                                        onClick: ($event: any) => (_ctx.toggleSelectAllForServer(server.name, true)),
                                        class: "mr-2"
                                      }, {
                                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                                          _createTextVNode("Select All")
                                        ])),
                                        _: 2,
                                        __: [4]
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_v_btn, {
                                        size: "small",
                                        onClick: ($event: any) => (_ctx.toggleSelectAllForServer(server.name, false))
                                      }, {
                                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                                          _createTextVNode("Deselect All")
                                        ])),
                                        _: 2,
                                        __: [5]
                                      }, 1032, ["onClick"])
                                    ]),
                                    _createVNode(_component_v_list, {
                                      dense: "",
                                      class: "hide-scrollbar",
                                      style: {"max-height":"300px","overflow-y":"auto"}
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(server.functions, (func) => {
                                          return (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: func.name,
                                            density: "compact"
                                          }, {
                                            prepend: _withCtx(() => [
                                              _createVNode(_component_v_checkbox_btn, {
                                                modelValue: _ctx.localSelectedFunctions[server.name],
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.localSelectedFunctions[server.name]) = $event),
                                                value: func.name,
                                                density: "compact"
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "value"])
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(func.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_list_item_subtitle, {
                                                title: func.description,
                                                class: "text-truncate"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(func.description), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["title"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["disabled"]))
                      }), 128))
                    ]),
                    _: 1
                  })),
              (!_ctx.loadingFunctions && _ctx.serversWithFunctions.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[6] || (_cache[6] = [
                    _createElementVNode("p", null, "No tools selected or no functions available for the selected tools.", -1)
                  ])))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: _ctx.closeDialog
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("Cancel")
                ])),
                _: 1,
                __: [7]
              }, 8, ["onClick"]),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "elevated",
                onClick: _ctx.saveSelection
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("Save Functions")
                ])),
                _: 1,
                __: [8]
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue"]))
}